import ProjectLanguageSelector from '../ProjectLanguageSelector';
import TitledTextField from '../TitledTextField';
import TitledPanel from '../TitledPanel';
import CancelButton from '../CancelButton';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import PrimaryButton from '../PrimaryButton';
import { lightSanitiseText } from '../utils/utils';
import { globalStyles as styles } from '../style/gstheme';

class RejectResourceDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            text: "",
            lang: this.props.defaultLang
        };
    }

    selectLanguage = (lang) => this.setState({ lang });

    addRejectionNote = () => this.props.addRejectionNote(this.state.text, this.state.lang);

    skipRejectionNote = () => this.props.addRejectionNote("");

    handleChange = event => {
        const t = event.target;
        const cleanText = lightSanitiseText(t.value.trimLeft());
        this.setState({ [t.name]: cleanText });
    };

    render() {

        const { classes, onCancel, existingNotes } = this.props;
        const { text, lang } = this.state;

        const existing = existingNotes && existingNotes[lang] ?
            Array.isArray(existingNotes[lang]) ?
                existingNotes[lang].includes(text)
                :
                existingNotes[lang] === text
            :
            false;

        return (
            <React.Fragment>
                <Dialog
                    data-test="reject-resource-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paperWidthMd: classes.mediumDialogOverflow
                    }}
                    open={true}
                    onClose={onCancel}
                    aria-labelledby="reject-resource-dialog-title">
                    <DialogTitle data-test="reject-resource-title" disableTypography className={classes.mainHeading} id="reject-resource-dialog-title">Reason for Rejection</DialogTitle>
                    <DialogContent data-test="reject-dialog" style={{ maxHeight: '500px', overflowY: 'scroll' }}>
                        <TitledPanel margin={true} title="Language">
                            <ProjectLanguageSelector selectedLang={lang} includeLabel={false} onSelect={this.selectLanguage} />
                        </TitledPanel>
                        <TitledTextField
                            dataTest="language-text"
                            name="text"
                            title={"Detail"}
                            margin={true}
                            placeholder="Enter a note relating to your rejection"
                            required={false}
                            text={text}
                            multiline={true}
                            helperText={
                                existing ?
                                    "This note already exists."
                                    :
                                    ""}
                            rows={3}
                            maxLength={500}
                            onEnter={text.length > 0 && lang !== "" ? this.addItem : null}
                            onChange={this.handleChange} />
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.skipRejectionNote}>Skip</CancelButton>
                        <PrimaryButton
                            dataTest="reject"
                            disabled={existing || text === ""}
                            onClick={this.addRejectionNote}>Add Note</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

RejectResourceDialog.propTypes = {
    classes: PropTypes.object,
    project: PropTypes.string.isRequired,
    existingNotes: PropTypes.object,
    addRejectionNote: PropTypes.func.isRequired,
    defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(RejectResourceDialog);